<template>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <div class="card-body card-body-phone pb-2 pt-2 pagination-content">
            <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center success rounded aling-pagination">
                    <li class="page-item" :class="{disabled:items.current_page===1?true:false}">
                        <router-link class="page-link" :to="to" @click="pageChange(1)"><span class="menu-text"><i
                                class="icon-chevrons-left"/></span></router-link>
                    </li>
                    <li class="page-item" :class="{disabled:items.current_page===1?true:false}">
                        <router-link class="page-link" :to="to" @click="pageChange(items.current_page-1)"><span
                                class="menu-text"><i class="icon-chevron-left1"/></span></router-link>
                    </li>
                    <li class="page-item mr-2"
                        :class="{active:item.active?'active':'', disabled:item.label==='...'?true:false}"
                        v-for="item in items.links" :key="item.key">
                        <router-link class="page-link" to="" v-if="item.label!='« Anterior' && item.label!='Próxima »'"
                                     @click="pageChange(item.label)">
                            <span class="menu-text"><span v-html="item.label"></span></span>
                        </router-link>
                    </li>
                    <li class="page-item" :class="{disabled:items.current_page===items.last_page?true:false}">
                        <router-link class="page-link" :to="to"
                                     @click="pageChange(items.current_page===items.last_page?items.last_page:items.current_page+1)">
                            <span class="menu-text"><i class="icon-chevron-right1"/></span>
                        </router-link>
                    </li>
                    <li class="page-item" :class="{disabled:items.current_page===items.last_page?true:false}">
                        <router-link class="page-link" :to="to" @click="pageChange(items.last_page)">
                            <span class="menu-text"><i class="icon-chevrons-right"/></span>
                        </router-link>
                    </li>
                </ul>
            </nav>
            <div class="pagination-page-size" v-if="havePerPage">
                <div class="pagination-page-size-options" role="group" aria-label="Registros por página">
                    <button
                            v-for="option in paginateOptions"
                            :key="option.id"
                            type="button"
                            class="btn pagination-page-size-option"
                            :class="{'active': perPage === option.id}"
                            :title="`${option.text} registros por página`"
                            @click="changePaginate(option.id)">
                        {{ option.text }}
                    </button>
                    <button
                            type="button"
                            class="btn pagination-page-size-option pagination-page-size-clear"
                            :class="{'active': !perPage}"
                            title="Limpar quantidade por página"
                            @click="changePaginate(null)">
                        Padrão
                    </button>
                </div>
            </div>
        </div>
        <div class="text-center d-flex justify-content-center" >
            <div style="width: max-content;" class="pl-2 pr-2 pt-1 pb-1 mb-0" >
               Página {{items?.current_page}} de {{items?.last_page}}, exibindo {{ items?.data?.length }} registros de {{items?.total}}.
            </div>
        </div>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";

export default {
    setup() {
        const {t} = useI18n();
        return {t}
    },
    data() {
        return {
            links: {}
        }
    },
    props: {
        items: {},
        to: {
            type: String,
            default: ''
        },
        havePerPage: {
            type: Boolean,
            default: false
        },
        perPage: {
            default: null
        },
        paginate: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        paginateOptions() {
            return this.paginate.filter(option => option.id !== 'selecione');
        }
    },
    created() {
        this.links = this.items
    },
    emits:['changePage', 'changePaginate'],
    methods: {
        pageChange(page) {
            this.$emit('changePage', page)
        },
        changePaginate(perPage) {
            this.$emit('changePaginate', perPage)
        },
    }
}
</script>
<style scoped>
.hooverlegend:hover{
    background-color: #0e5e4e;
    color: #ffffff
}

.pagination-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
}

.pagination-content > nav {
    grid-column: 2;
}

.pagination-page-size {
    grid-column: 3;
    justify-self: end;
}

.pagination-page-size-options {
    display: inline-flex;
    gap: 0.18rem;
    white-space: nowrap;
    padding: 0.18rem;
    border: 1px solid #edf1f5;
    border-radius: 999px;
    background: #f8fafc;
    box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 18px rgba(15, 23, 42, 0.05);
}

.pagination-page-size-option {
    min-width: 38px;
    padding: 0.36rem 0.62rem;
    border: 0;
    border-radius: 999px;
    color: #727272;
    font-size: 0.76rem;
    font-weight: 800;
    background: transparent;
    line-height: 1.15;
    transition: background-color .16s ease, color .16s ease, box-shadow .16s ease, transform .16s ease;
}

.pagination-page-size-option:hover,
.pagination-page-size-option:focus {
    color: #0e5e4e;
    background: #ffffff;
    box-shadow: none;
}

.pagination-page-size-option.active {
    color: #ffffff;
    background: #0e5e4e;
    box-shadow: 0 5px 12px rgba(14, 94, 78, 0.22);
}

.pagination-page-size-clear {
    min-width: 62px;
    color: #9ca3af;
    font-weight: 700;
}

.pagination-page-size-clear:hover,
.pagination-page-size-clear:focus {
    color: #0e5e4e;
    background: #ffffff;
}

@media (max-width: 1199.98px) {
    .pagination-content {
        display: block;
    }

    .pagination-page-size {
        display: flex;
        justify-content: center;
        margin-top: 0.5rem;
    }
}
</style>
